import { Injectable } from '@angular/core';
import { FeatureMock } from '../DataStore/Mock/feature-mock';
import { FeatureModel } from '../Models/feature-model';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureServiceService {
  constructor(private rest: RestService) { }

  public findByObjectId(id: string): FeatureModel {
    return FeatureMock.findByObjectId(id);

  }

  public findById(id: number): FeatureModel {
    return FeatureMock.findById(id);
  }

  public getItems(): Observable<FeatureModel[]> {
    let projectId = localStorage.getItem("projectId");
    return this.rest.get('projectFeatures', projectId);
  }

  public addNew(name: string, mydata: any) {
    let projectId = localStorage.getItem("projectId");
    let model = new FeatureModel();
    model.name = name;
    var data = {
      project: { _id: projectId },
      feature: model
    };
    return this.rest.put('addfeature', data);
  }

  public edit(model) {
    let projectId = localStorage.getItem("projectId");
    if(model.models){
      model.models = model.models.map(m=>{return m=m.$oid});
    }
    // if (model.created_time) {
    //   delete model.created_time;
    //   }
    // if (model.updated_time) {
    //   delete model.updated_time;
    //   }
    model.created_time=model.created_time.$numberLong;
    model.updated_time=model.updated_time.$numberLong;
    var data = {
      project: { _id: projectId },
      feature: model
    };
    return this.rest.post('updatefeature', data);
  }

  public deleteModel(model) {
    let projectId = localStorage.getItem("projectId");
    if(model.models){
      model.models = model.models.map(m=>{return m=m.$oid});
    }
    // if (model.created_time) {
    //   delete model.created_time;
    //   }
    // if (model.updated_time) {
    //   delete model.updated_time;
    //   }
    model.created_time=model.created_time.$numberLong;
    model.updated_time=model.updated_time.$numberLong;
    var data = {
      project: { _id: projectId },
      feature:  model
    };
    return this.rest.post("deletefeature", data);
  }

  public saveAsModel(model) {
    let projectId = localStorage.getItem("projectId");
    // delete model._id;
    // if (model.created_time) {
    //   delete model.created_time;
    //   }
    // if (model.updated_time) {
    //   delete model.updated_time;
    //   }
    model.created_time=model.created_time.$numberLong;
    model.updated_time=model.updated_time.$numberLong;
      if(model.models){
        const modelIds = model.models.map(model => model.$oid);
        model['models'] = modelIds;}
    let data = {
      project: { _id: projectId },
      feature: model
    };
      console.log(model);
      return this.rest.put('copyfeature', data);
  }
}